const $inject = [];

const cssClassNameFilter = () => {
  return (str) => {
    if (!str) return '';

    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
      })
      .replace(/\s+/g, '');
  };
};

cssClassNameFilter.$inject = $inject;

export default cssClassNameFilter;



// WEBPACK FOOTER //
// ./src/filters/cssClassNameFilter.js